import React from "react"
import EmptyCalenderLogo from "../../../images/empty_calendar.svg"
import {
  Accordion,
  AccordionContent,
  AccordionTitle,
  Button,
  Card,
  Icon,
  Image,
  Label
} from "semantic-ui-react"
import DatePicker from "react-datepicker"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { datePickerLocale } from "../../../v1/helpers/translationHelpers"
import moment from "moment"
import { CART_EVENTS, DATE_TIME_FORMAT, WALK_IN_TIME } from "../../../v1/constants/application"
import { isCaradvise, isEbayCart, isEbayUser } from "../../../v1/helpers/affiliationHelpers"
import { parseInt } from "lodash"
import { getNewTiresServiceFromServices } from "../../../v1/helpers/orderServiceHelpers"
import { getJSON } from "../../../shared_component/utils/fetch"
import ItemSelector from "../../../v1/components/ItemSelector"
import { findNextAvailableDate, isDayDisabled } from "../../../shared_component/utils/dateHelpers"
import { getUpdatedCart, isEbayTireOrder } from "../../../v1/helpers/orderHelpers"
import SelectedShopCard from "../Schedule/Shop/SelectedShopCard"
import {
  appointmentDateTimeSelectedEvents,
  gaJSON,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"
import { updateCart } from "../../../v1/actions/user"
import { WALKIN } from "../../../v1/constants/order"
import { withRouter } from "react-router-dom"
import { routerPaths } from "../../../v1/constants/paths"
import { getPaymentMethods } from "../../../v1/actions/paymentMethods"
import SelectedShop from "./SelectedShop"
import InfoIcon from "../../../images/info_icon_vector.svg"
import questionCircle from "../../../images/question-circle.svg"

const resetState = {
  date: null,
  timeSlots: null,
  time: null,
  dateTimesHash: {},
  loading: false,
  loadingMessage: "",
  slotLoading: false,
  activeIndex: 0,
  isSubmitting: false
}
class Appointment extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ...resetState
    }
  }

  componentDidMount() {
    const { cart, user } = this.props
    const isEbayTireCart = isEbayUser(user) && isEbayTireOrder(cart)
    let date =
      cart && cart.appointment_datetime
        ? moment(cart.appointment_datetime, moment.defaultFormat).utc().toDate()
        : moment(new Date(), moment.defaultFormat).add(1, "day").utc().toDate()

    if (cart && !cart.appointment_datetime) {
      date = findNextAvailableDate(date)
    }
    if (!isEbayTireCart) {
      this.onDateChange(date)
    }
    this.loadPaymentData()
  }

  hoursBlockedDateTimeCalculator = (date) => {
    const { cart } = this.props

    const totalTime = cart?.shop?.offset_availability || cart?.shop?.company?.offset_availability

    if (!totalTime || totalTime <= 0) return null

    const days = Math.floor(totalTime / 24)
    const remainingHours = totalTime % 24

    const blockedUntil = moment().add(days, "days").add(remainingHours, "hours")

    return blockedUntil
  }

  loadPaymentData = async () => {
    const { braintreePaymentMethods, getPaymentMethods, user } = this.props

    if (!braintreePaymentMethods || braintreePaymentMethods.length == 0) {
      this.setState({ slotLoading: true })
      await getPaymentMethods(user)
      this.setState({ slotLoading: false })
    }
  }

  componentDidUpdate(prevProps) {
    const { cart } = this.props
    let date =
      cart && cart.appointment_datetime
        ? moment(cart.appointment_datetime, moment.defaultFormat).utc().toDate()
        : moment(new Date(), moment.defaultFormat).add(1, "day").utc().toDate()

    if (this.props.shop && prevProps.cart.shop) {
      if (this.props.shop.id !== prevProps.cart.shop.id) {
        this.onDateChange(date)
        this.resetState()
      }
    }
  }

  resetState = () => {
    this.setState({
      ...resetState
    })
  }

  onDateChange = async (date) => {
    if (!moment(date).isSame(this.state.date, "day")) {
      this.setState({ date: date, slotLoading: true })
      if (!moment(date).isSame(moment(), "day")) {
        let time_data = await this.fetchTimeSlots(date)
        this.setTimeSlots(date, time_data)
      } else {
        this.setTimeSlots(date, [])
      }
      this.setState({ slotLoading: false })
    }
  }

  onTimeSelect = async (value) => {
    const { t } = this.props
    this.setState({ time: value })
    this.setLoadingState(t("updatingAppointmentTimeLoadingMessage"))
    this.clearLoadingState()
  }

  fetchTimeSlots = async (date) => {
    const { t } = this.props
    this.setLoadingState(t("RetrievingShopTimeLoadingMessage"))
    const dateTimesKey = moment(date).format(DATE_TIME_FORMAT.YYYY_MM_DD)
    let data = this.state.dateTimesHash[dateTimesKey] || (await this.fetchTimeSlotsFromServer(date))

    this.clearLoadingState()

    return data && data.times ? data.times : null
  }

  fetchTimeSlotsFromServer = async (date) => {
    let { user } = this.props
    const date_string = moment(date).format(DATE_TIME_FORMAT.YYYYMMDD)

    const authentication_token = this.props.user.authentication_token

    const orderLikeObject = this.fetchOrderLikeObject(user)
    const shopId =
      orderLikeObject && orderLikeObject.shop ? orderLikeObject.shop.id : orderLikeObject.shop_id

    if (shopId === null || shopId === undefined) {
      return
    }

    let orderLikeIdParam

    if (orderLikeObject.status !== undefined) orderLikeIdParam = `&order_id=${orderLikeObject.id}`
    else orderLikeIdParam = `&cart_id=${orderLikeObject.id}`

    let response = await getJSON(
      `/api/v4/shops/${shopId}/schedule?date=${date_string}&days=1${orderLikeIdParam}`,
      {},
      { Authorization: authentication_token }
    )

    let data = response.result && response.result[0] ? response.result[0] : null
    const dateTimesKey = moment(date).format(DATE_TIME_FORMAT.YYYY_MM_DD)
    let dateTimesHash = { ...this.state.dateTimesHash }
    dateTimesHash[dateTimesKey] = data
    this.setState({ dateTimesHash: dateTimesHash })

    return data
  }

  setTimeSlots = async (date, times) => {
    const { t } = this.props
    const orderLikeObject = this.fetchOrderLikeObject()
    const walkInsOnly =
      ((orderLikeObject && orderLikeObject.shop && orderLikeObject.shop.company) || {})
        .walk_ins_only || orderLikeObject.is_walk_in

    const walkIn = {
      formatted_time: t("shopAppointmentPicker:walkInText"),
      time: moment(date).set({ hour: "3", minute: "00" })
    }
    const blockedUntil = this.hoursBlockedDateTimeCalculator()
    if (walkInsOnly) {
      this.setState({ timeSlots: [walkIn], time: null })
    } else if (times) {
      const filteredTimes = blockedUntil
        ? times.filter((tm) => {
            let hour_min = tm.split(":")
            let hour = parseInt(hour_min[0])
            let min = parseInt(hour_min[1])
            const dt = moment(date).set({ hour: hour, minute: min })
            if (blockedUntil && dt.isBefore(blockedUntil)) {
              return false
            }
            return true
          })
        : times
      let timesData = filteredTimes.map((tm) => {
        let hour_min = tm.split(":")
        let hour = parseInt(hour_min[0])
        let min = parseInt(hour_min[1])
        const dt = moment(date).set({ hour: hour, minute: min })
        if (this.props.i18n.language === "en") {
          let ampm = DATE_TIME_FORMAT.AM
          if (hour === 12) {
            ampm = DATE_TIME_FORMAT.PM
          } else if (hour > 12) {
            hour = hour - 12
            ampm = DATE_TIME_FORMAT.PM
          } else if (hour === 0) {
            hour = 12
          }
          return { formatted_time: `${hour}:${hour_min[1]} ${ampm}`, time: dt }
        } else {
          return { formatted_time: `${hour}:${hour_min[1]}`, time: dt }
        }
      })

      if (this.enableWalkIn(date)) timesData.unshift(walkIn)

      this.setState({ timeSlots: timesData, time: null })
    } else {
      const timeSlots = this.enableWalkIn(date) ? [walkIn] : null
      this.setState({ timeSlots: timeSlots, time: null })
    }
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }

  handleShopChange = () => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_change_selected_shop_appointment_page
    })
    const { history } = this.props
    history.push({
      pathname: routerPaths.shopSelection
    })
  }

  isWalkin = (dateTime) => {
    const { timeSlots } = this.state
    if (dateTime) {
      const date_str = dateTime.format(DATE_TIME_FORMAT.MM_DD_YYYY_H_M)
      return date_str.includes(WALK_IN_TIME)
    }
    if (timeSlots) {
      if (timeSlots.length === 1 && timeSlots[0].formatted_time === WALKIN) {
        return true
      }
    }

    return false
  }

  isWalkinOnly = () => {
    const { timeSlots } = this.state
    if (timeSlots) {
      if (timeSlots.length === 1 && timeSlots[0].formatted_time === WALKIN) {
        return true
      }
    }
    return false
  }

  onDateTimeSubmit = async () => {
    const {
      updateCart,
      activeVehicle,
      order,
      history,
      braintreePaymentMethods,
      isCart,
      cart
    } = this.props
    const { time, timeSlots } = this.state
    let dateTime = time

    trackFirebaseAnalytics({
      event: gaJSON.EtoB_proceed_to_review
    })

    let opts = {
      isOrder: order && !order.is_tire_order,
      orderId: order && order.id,
      successCallback: async (response) => {
        await appointmentDateTimeSelectedEvents({ response, activeVehicle })
      }
    }
    if (timeSlots.length === 1 && timeSlots[0].formatted_time === WALKIN) {
      dateTime = timeSlots[0].time
    }

    if (dateTime) {
      this.setState({ isSubmitting: true })
      const date_str = dateTime.format(DATE_TIME_FORMAT.MM_DD_YYYY_H_M)
      const event_type = date_str.includes(WALK_IN_TIME)
        ? CART_EVENTS.SET_WALK_IN
        : CART_EVENTS.SET_TIME
      const response = await updateCart(
        [{ event: event_type, appointment_datetime: date_str }],
        this.props.activeVehicle.id,
        null,
        undefined,
        opts
      )
      if (response && response().result) {
        const isEbayOrder = isEbayTireOrder(cart)

        if (isEbayOrder) {
          trackFirebaseAnalytics({
            event: gaJSON.ebay_schedule_completed,
            params: { appointment_date: date_str }
          })

          if (isCart) {
            history.push({ pathname: routerPaths.recommendedServices })
            return
          }

          history.push({ pathname: routerPaths.reviewRequest })
          return
        }

        trackFirebaseAnalytics({
          event: gaJSON.EtoB_proceed_to_payment
        })
        history.push({ pathname: routerPaths.reviewRequest })
      }
      this.setState({ isSubmitting: false })
    }
  }

  addBusinessDays(date, businessDaysToAdd) {
    let current = moment(date)
    let addedDays = 0

    while (addedDays < businessDaysToAdd) {
      current.add(1, "day")
      if (current.day() !== 0) {
        addedDays++
      }
    }

    return current
  }

  render() {
    const { cart, t, user, isCart, braintreePaymentMethods } = this.props
    const { slotLoading, activeIndex } = this.state
    const date_str = this.state.date ? moment(this.state.date).format(DATE_TIME_FORMAT.LLLL) : ""
    const isEbayTireCart = isEbayUser(user) && isEbayTireOrder(cart)
    const emptyMessage =
      this.state.date && !this.state.loading
        ? `${t("shopAppointmentPicker:noTimeAvailableText")} ${date_str}`
        : this.state.loading
        ? t("shopAppointmentPicker:loadingMessage")
        : t("shopAppointmentPicker:selectDateFirstLbl")

    let minDate = cart && cart.valid_at ? moment(cart.valid_at) : moment()
    const blockedUntil = this.hoursBlockedDateTimeCalculator()

    if (blockedUntil) {
      const hour = blockedUntil.hour()
      if (hour >= 17) {
        minDate = blockedUntil.add(1, "day")
      } else {
        minDate = blockedUntil
      }
      if (moment(this.state.date) < blockedUntil) {
        this.onDateChange(minDate.toDate())
      }
    }

    if (isEbayTireCart) {
      if (cart?.ebay_order_date) {
        const orderDate = moment(cart.ebay_order_date)
        minDate = this.addBusinessDays(orderDate, 5)
      } else {
        minDate = isCart ? moment() : moment(cart?.appointment_datetime)
      }
    }

    if (minDate < moment()) minDate = moment()
    return (
      <Card className="appointment-card" raised={true}>
        <div>
          {!isEbayTireCart && cart.shop && (
            <SelectedShopCard
              cart={cart}
              shop={cart.shop}
              handleShopChange={this.handleShopChange}
            />
          )}
          {isEbayTireCart && cart.shop && <SelectedShop shop={cart.shop} />}
          <div className="shop-slect-date-time-container">
            {cart && !cart.shop ? (
              <div className="no-shop-select-image-container">
                <Image src={EmptyCalenderLogo} />
              </div>
            ) : (
              <>
                {cart && cart.order_services.length > 0 ? (
                  <>
                    <Accordion fluid>
                      <AccordionTitle
                        active={activeIndex === 0}
                        index={0}
                        onClick={this.handleClick}
                      >
                        <Icon className="accordion_icon" name="chevron down" />
                        <Label circular color="black" key="black">
                          1
                        </Label>
                        {t("shopAppointmentPicker:selectDateLabel")}
                        {this.state.date && (
                          <Icon className="check_icon" color="green" name="check circle" />
                        )}
                        <div className="selected_content">
                          {this.state.date && moment(this.state.date).format(DATE_TIME_FORMAT.LL)}
                        </div>
                      </AccordionTitle>
                      <AccordionContent active={activeIndex === 0}>
                        {isEbayTireCart && (
                          <Card fluid className="time_service">
                            <Image src={InfoIcon} className="info-icon" />
                            {t(
                              "The first four business days are blocked to allow time for tire delivery."
                            )}
                          </Card>
                        )}
                        <div className="no-shop-select-image-container">
                          <DatePicker
                            inline
                            selected={this.state.date}
                            onChange={(date) => {
                              this.onDateChange(date)
                              this.setState({ activeIndex: 1 })
                            }}
                            minDate={minDate._d}
                            locale={datePickerLocale()}
                            filterDate={isDayDisabled}
                          />
                        </div>
                      </AccordionContent>
                    </Accordion>
                    {!slotLoading ? (
                      <div className="select-time-container">
                        {this.isWalkinOnly() ? (
                          <div className="walk-in-only">
                            <div className="walk-in-header">
                              <Label circular color="black" key="black">
                                2
                              </Label>
                              {t("shopAppointmentPicker:selectTimeLbl")}
                              {(this.isWalkin(this.state.time) || this.state.time) && (
                                <Icon className="check_icon" color="green" name="check circle" />
                              )}
                            </div>
                            <div className="selected_content">
                              {t("shopAppointmentPicker:WalkInOnly")}
                              <Card fluid className="walk_in_service">
                                <Icon className="info-icon" name="sign in" />
                                {t("shopAppointmentPicker:busySchedule")}
                                <span>
                                  &nbsp; {t("shopAppointmentPicker:callAhead")}
                                  <a href={`tel:+1-${cart?.shop?.main_phone_number}`}>
                                    {cart?.shop?.main_phone_number}.
                                  </a>
                                </span>
                              </Card>
                            </div>
                          </div>
                        ) : (
                          <Accordion fluid>
                            <AccordionTitle
                              active={activeIndex === 1}
                              index={1}
                              onClick={this.handleClick}
                            >
                              <Icon className="accordion_icon" name="chevron down" />
                              <Label circular color="black" key="black">
                                2
                              </Label>
                              {t("shopAppointmentPicker:selectTimeLbl")}
                              {(this.isWalkin(this.state.time) || this.state.time) && (
                                <Icon className="check_icon" color="green" name="check circle" />
                              )}
                              <div className="selected_content">
                                {this.isWalkin(this.state.time) ? (
                                  <div>
                                    {t("shopAppointmentPicker:WalkInOnly")}
                                    <Card fluid className="walk_in_service">
                                      <Icon className="info-icon" name="sign in" />
                                      {t("shopAppointmentPicker:busySchedule")}
                                      <span>&nbsp; {t("shopAppointmentPicker:callAhead")}</span>
                                      <a href={`tel:+1-${cart?.shop?.main_phone_number}`}>
                                        {cart?.shop?.main_phone_number}.
                                      </a>
                                    </Card>
                                  </div>
                                ) : (
                                  <div>
                                    {this.state.time && (
                                      <div>
                                        {moment(this.state.time)
                                          .format(DATE_TIME_FORMAT.HH_MM)
                                          .toUpperCase()}
                                        <Card fluid className="time_service">
                                          <Icon className="info-icon" name="clock outline" />
                                          {t("shopAppointmentPicker:willTextYou")}
                                        </Card>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </AccordionTitle>
                            <AccordionContent active={activeIndex === 1}>
                              {isEbayTireCart && (
                                <Card fluid className="time_service mrg-btm-10">
                                  <Image src={InfoIcon} className="info-icon" />
                                  {t(
                                    "Tires typically take 2 to 4 hours to install, depending on shop workload.  "
                                  )}
                                </Card>
                              )}
                              <div className="time-slots">
                                <ItemSelector
                                  items={this.state.timeSlots}
                                  labelField="formatted_time"
                                  valueField="time"
                                  emptyMessage={emptyMessage}
                                  value={this.state.time}
                                  onSelect={this.onTimeSelect}
                                  cart={cart}
                                />
                              </div>
                              {!this.isWalkin(this.state.time) && !isEbayTireCart && (
                                <Card fluid className="time_service">
                                  <Icon className="info-icon" name="clock outline" />
                                  {t("shopAppointmentPicker:willTextYou")}
                                </Card>
                              )}
                            </AccordionContent>
                          </Accordion>
                        )}
                      </div>
                    ) : (
                      <p>Loading..</p>
                    )}
                  </>
                ) : (
                  <div>{t("common:noAddedServiceText")}</div>
                )}
              </>
            )}
          </div>
        </div>
        <Card fluid className="trouble-scheduling-card">
          <Image src={questionCircle} />
          <p>
            {t("Having trouble scheduling? We're here to help. Call")} <b> (844) 923-8473.</b>
          </p>
        </Card>
        <div className="action_button">
          <Button
            fluid
            loading={this.state.isSubmitting}
            onClick={this.onDateTimeSubmit}
            disabled={
              !(this.state.date && (this.state.time || this.isWalkin(this.state.time))) ||
              this.state.isSubmitting ||
              cart.order_services.length == 0
            }
            className="primary-button"
          >
            {isEbayTireCart ? "Review appointment" : t("tirePayment:confirmAndContinue")}
          </Button>
        </div>
      </Card>
    )
  }

  fetchOrderLikeObject() {
    let { user, orderLikeObject, cart } = this.props
    return (
      orderLikeObject ||
      cart ||
      (user &&
        user.active_carts &&
        user.active_carts.find((c) => c.vehicle_id === user.activeVehicleId))
    )
  }

  enableWalkIn = (date) => {
    const { user } = this.props
    const momentDate = moment(date)
    var isSunday = date.getDay(0)
    const cart = this.fetchOrderLikeObject()
    const isEbay = isEbayCart(user)
    const isBlackoutDate = [
      { month: 11, day: 25 } // Christmas
    ].find((bod) => bod.month === momentDate.month() && bod.day === momentDate.date())

    return (
      !this.props.disableWalkIns &&
      isSunday &&
      !isEbay &&
      !isBlackoutDate &&
      !this.hasNewTiresWithTireConnect(cart)
    )
  }

  hasNewTiresWithTireConnect(cart) {
    return (
      cart.shop &&
      cart.shop.supports_tire_selection &&
      !!getNewTiresServiceFromServices(cart.order_services)
    )
  }

  setLoadingState(message) {
    this.setState({ loading: true, loadingMessage: message })
  }

  clearLoadingState() {
    this.setState({ loading: false, loadingMessage: "" })
  }
}

function mapStateToProps(state, props) {
  let user = state.user
  const braintreePaymentMethods = Array.isArray(state?.paymentMethods?.braintreePaymentMethods)
    ? state.paymentMethods.braintreePaymentMethods.filter((method) => method?.type !== "ach")
    : []
  let cart
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)
  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  }
  return {
    user,
    cart: cart || {},
    order,
    activeVehicle,
    braintreePaymentMethods,
    isCart: updatedCartData.isCart
  }
}

export default withRouter(
  connect(mapStateToProps, {
    updateCart,
    getPaymentMethods
  })(withTranslation(["checkout", "shopAppointmentPicker", "tirePayment"])(Appointment))
)
